module.exports = __webpack_public_path__ + "static/gosite-promo-4bb15b2b3322a52387f7b56566d15e38.mp4";